import React from "react";
import Breadcrumb from "./Breadcrumb";
import "../styles/Profile.css";

const NoOpenMatterPage = () => {
  return (
    <div className="main-wrapper">
      <Breadcrumb items={[{ label: "Meus Casos" }, { label: "Situação da conta" }]} />

      <div className="profilePage">
        <section className="profileCard">
          <div className="profileHeader">
            <h1 className="profileTitle">Situação da conta</h1>
            <p className="profileSubtitle">
              Verificamos os dados disponíveis para este acesso.
            </p>
          </div>

          <div className="profileEmpty">
            <div className="profileEmptyTitle">
              Não localizamos um caso elegível
            </div>
            <div className="profileEmptySub">
              Lamentamos, mas no momento não identificamos nenhum caso válido e
              em andamento vinculado a este CPF.
            </div>
            <p className="profileFooterNote">
              Assim que houver uma atualização cadastral ou processual
              aplicável, ela será refletida neste portal.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NoOpenMatterPage;
